import React from 'react'
import "./Common_subHeading.css"

function Common_subHeading({subHeading}) {
  return (
<>
<section className='Common_subHeading'>
    <h4>{subHeading}</h4>
</section>
</>
  )
}

export default Common_subHeading